export enum WageAndTravelDrawerViewType {
    DonorRequest = 0,
    ReimburseWage = 1,
    ReimburseTravel = 2,
    Verify = 3,
    Confirm = 4,
    RequestAdditionalDays = 5
}